import React, { Component } from "react";
import { Row, Col } from "reactstrap";
import { translate } from "react-i18next";
import styled from "styled-components";
import i18n from "../i18n";

import { Button } from "ia-react-ui-components";

import Header from "./Header";
import PageErrorFooter from "./PageErrorFooter";
import GenerateInputArea from "./GenerateInputArea";
import Validation from "./Validation";
import ModalCancel from "./ModalCancel";

const LinkCancel = styled.a`
  body && {
    font-size: 16px;
    font-family: "Open Sans", "Helvetica Neue", Helvetica, Arial, sans-serif;
    font-weight: 600;
  }
`;

export class SectionTwo extends Component {
  constructor(props) {
    super(props);

    let sessionInterview = JSON.parse(sessionStorage.getItem("interview"));
    let sessionHideSec2Part1 = sessionStorage.getItem("hideSec2Part1");

    if (sessionInterview) {
      this.props.interview.sections = sessionInterview.sections;
    }

    this.props.interview.lang = i18n.language.includes("en")? "en": "fr" ;

    this.state = {
      questions: this.props.interview.sections[this.props.step].questions,
      groups: this.props.interview.sections[this.props.step].groups,
      isValid: this.props.interview.sections[this.props.step].isValid,
      hideSec2Part1: sessionHideSec2Part1 || "1",
      cancelVisible: false,
      isModalVisible: false
    };
  }

  ////////////////////
  //Common Functions//
  componentDidMount() {
    window.scrollTo(0, 0);
  }

  openModal = () => {
    this.setState({ isModalVisible: true });
  };

  closeModal = () => {
    this.setState({ isModalVisible: false });
  };
  //End Common Functions//
  ////////////////////////

  goToPage = direction => {
    this.save();

    if (direction === "previous") {
      this.props.history.push("/SectionOne");
    } else {
      this.validate();
    }
  };

  validate = event => {
    if (
      Validation.validator(
        this.props.interview.sections[this.props.step].questions,
        this.props.interview.lang,
        this.props.interview.sections[this.props.step].groups
      ) === false
    ) {
      this.setState({ isValid: false }, () => {
        this.save();
      });
    } else {
      this.setState({ isValid: true }, () => {
        this.save(), this.props.history.push("/SectionThree");
      });
    }
  };

  save = () => {
    this.setState({ questions: this.props.questions });
    this.props.interview.sections[this.props.step].isValid = this.state.isValid;

    sessionStorage.setItem("interview", JSON.stringify(this.props.interview));
  };

  hideHandler = value => {
    let groups = this.props.interview.sections[this.props.step].groups;

    if (value === "4") {//Other
      groups[0].hide = false;
    } else {
      groups[0].hide = true;
    }

    this.setState({ group: groups }, () => {
      this.props.interview.groups = this.state.groups;
    });
  };

  render() {
    const { t } = this.props;
    var questions = this.props.interview.sections[this.props.step].questions;
    var lang = this.props.interview.lang;

    var layout = [
      [["q1"]],
      [["q2"], ["q3"]],
      [["q4"], ["q5"], ["q6"], ["q7"], ["q8"]],
      [["q8a"]],
      [["q9"]]
    ];

    return (
      <React.Fragment>
        <ModalCancel
          isVisible={this.state.isModalVisible}
          closeModal={this.closeModal}
          history={this.props.history}
          clearInterview={this.props.clearInterview}
        />

        <Header step={this.props.step + 1} lang={lang}/>

        <h1>
          {this.props.interview.lang === "en"
            ? this.props.interview.sections[this.props.step].name_e
            : this.props.interview.sections[this.props.step].name_f}
        </h1>
        <div className="injectIaStyles">
          <GenerateInputArea
            layout={layout[0]}
            lang={lang}
            questions={questions}
          />

          <h2>{t("section_certificateFinancial.header2")}</h2>
          <GenerateInputArea
            layout={layout[1]}
            lang={lang}
            questions={questions}
          />

          <h2>{t("section_certificateFinancial.header3")}</h2>
          <GenerateInputArea
            layout={layout[2]}
            lang={lang}
            questions={questions}
            hideHandler={this.hideHandler}
          />
          <div hidden={this.state.groups[0].hide}>
            <GenerateInputArea
              layout={layout[3]}
              lang={lang}
              questions={questions}
            />
          </div>
          <GenerateInputArea
            layout={layout[4]}
            lang={lang}
            questions={questions}
          />

          <Row>
            <Col sm="2">
              <Button id="btnPrev" onClick={() => this.goToPage("previous")}>
                {t("common.previous")}
              </Button>
            </Col>
            <Col sm="2">
              <Button id="btnNext" onClick={() => this.goToPage("next")}>
                {t("common.next")}
              </Button>
            </Col>
            <Col sm="2">
              <div style={{ verticalAlign: "middle", lineHeight: "45px" }}>
                <LinkCancel onClick={this.openModal}>
                  {t("common.cancel")}
                </LinkCancel>
              </div>
            </Col>
            <Col sm="6">
              <div hidden={this.state.isValid}>
                <PageErrorFooter />
              </div>
            </Col>
          </Row>
        </div>
      </React.Fragment>
    );
  }
}

export default translate("translate")(SectionTwo);
